import React from "react";
import { Tooltip as AntTooltip, TooltipProps } from "antd";

/**
 * How long a tooltip waits before it appears.
 *
 * antd's own default is 0.1s, which is right for a lone control and wrong for a
 * row of them: a toolbar or a column of icon actions is read by running the
 * pointer along it, and at 0.1 that is a run of labels flashing in and out. The
 * delay lets the pointer pass through and answers only the hand that stops.
 */
export const TOOLTIP_DELAY = 0.6;

/**
 * antd's Tooltip with the app's own delay already on it.
 *
 * A wrapper rather than a setting, because antd has no setting for this:
 * `ConfigProvider.tooltip` takes className, style, styles, classNames, arrow,
 * trigger and unique — the delay is not among them. Passing the prop at every
 * call site is the alternative, and that is a rule nobody can keep.
 *
 * Everything else is antd's: import this instead of antd's Tooltip and the
 * component behaves exactly as documented, delay aside, which a call site can
 * still override.
 */
export default function Tooltip({
  mouseEnterDelay = TOOLTIP_DELAY,
  ...props
}: TooltipProps) {
  return <AntTooltip mouseEnterDelay={mouseEnterDelay} {...props} />;
}
